import React, { useEffect, useState } from 'react';
import Flex from 'components/common/Flex';
/* import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; */
/* import { AvatarGroup } from 'components/common/Avatar'; */
import PropTypes from 'prop-types';
import Avatar from 'components/common/Avatar';
import btn from 'assets/img/pay-methods/btn.png';
import nequi from 'assets/img/pay-methods/nequi.webp';
import pse from 'assets/img/pay-methods/pse.png';
import efecty from 'assets/img/pay-methods/efecty.png';
/* import cards from 'assets/img/pay-methods/cards.png'; */
import rcb from 'assets/img/pay-methods/rcb.png';
import card from 'assets/img/pay-methods/card.png';
import PayMethod from './PayMethod';
import CardForm from './methods/CardForm';
import ButonForm from './methods/ButonForm';
import NequiForm from './methods/NequiForm';
import EfectyForm from './methods/EfectyForm';
import PseForm from './methods/PseForm';
import RcbForm from './methods/RcbForm';
const initialMethods = [
 { id: 0, src: card, title: 'Targetas', note: 'Debito Credito', type: 'CARD' },
 { id: 1, src: nequi, title: 'Nequi', note: 'Wompy', type: 'NEQUI' },
 {
  id: 2,
  src: btn,
  title: 'Boton',
  note: 'Bancolombia',
  type: 'BANCOLOMBIA_TRANSFER'
 },
 { id: 3, src: pse, title: 'Pse', note: 'Transfiere', type: 'PSE' },
 {
  id: 4,
  src: efecty,
  title: 'Efectivo',
  note: 'Coresponsales',
  type: 'BANCOLOMBIA_COLLECT'
 },
 { id: 5, src: rcb, title: 'Recibo', note: 'Consignacion', type: 'RCB' }
];

const PayMethods = ({ method, setMethod, watch, register, setValue, errors }) => {
 const [hover, setHover] = useState(null);
 const [methods] = useState(initialMethods);

 useEffect(() => {
  setMethod(initialMethods[0]);
 }, []);

 return (
  <>
   <Flex className="mb-3">
    <div className="flex-grow-1 d-none d-sm-block">
     <Flex className="fs--2" alignItems="center" wrap="wrap">
      <Avatar src={hover?.src || method?.src} size={'4xl'} className="me-3" />
      <div className="flex-1 ps-3 border-start border-start-dark">
       <h5 className="mb-0 text-primary">
        <span className="bg-100 dark__bg-1100 pe-3">{hover?.title || method?.title}</span>
       </h5>
       <span className="bg-100 dark__bg-1100 pe-3">{hover?.note || method?.note}</span>
      </div>
     </Flex>
    </div>

    {methods.map((e, i) => (
     <PayMethod key={i} id={method.id} setHover={setHover} method={e} setMethod={setMethod} />
    ))}
   </Flex>

   {
    {
     Targetas: <CardForm show={true} register={register} setValue={setValue} errors={errors} />,
     Boton: <ButonForm show={true} src={method.src} register={register} setValue={setValue} errors={errors} />,
     Nequi: <NequiForm show={true} src={method.src} register={register} setValue={setValue} errors={errors} />,
     Efectivo: <EfectyForm show={true} setValue={setValue} />,
     Pse: <PseForm show={true} src={method.src} register={register} setValue={setValue} errors={errors} />,
     Recibo: <RcbForm show={true} register={register} watch={watch} setValue={setValue} errors={errors} />
    }[method.title]
   }
  </>
 );
};

PayMethods.propTypes = {
 method: PropTypes.object,
 setMethod: PropTypes.func,
 watch: PropTypes.func,
 register: PropTypes.func,
 setValue: PropTypes.func,
 errors: PropTypes.object
};

export default PayMethods;
